/**
 * Workflow Generation State
 * Manages the state of AI workflow generation (loading, progress, etc.)
 */

import { atom } from "jotai";

/**
 * Is the AI currently generating a workflow?
 */
export const isGeneratingWorkflowAtom = atom(false);

/**
 * Workflow generation progress
 */
export interface WorkflowGenerationProgress {
  elapsedTime: number; // in seconds
  progress: number; // 0-100
  currentStep: number; // 0-3 (which block is currently active)
}

export const workflowGenerationProgressAtom = atom<WorkflowGenerationProgress>({
  elapsedTime: 0,
  progress: 0,
  currentStep: 0,
});
